import type {StateCreator} from 'zustand'
import type {FileKey, LineKey} from '../../types'

export type StoredCommentSlice = {
  // for the purposes of diff lines themselves, we only care about whether or not a stored comment exists
  // on a given line. The actual value will be accessed from the persisted storage by the commenting components,
  // we just need to know whether or not to open up the new comment UI.
  storedCommentsMap: {
    [key: LineKey | FileKey]: boolean
  }
  getStoredCommentDataForLine: (lineKey: LineKey | FileKey) => boolean | undefined
  updateStoredCommentOnLine: (lineKey: LineKey | FileKey, hasStoredComment: boolean) => void
}

export const FileLevelCode = 'F0' as FileKey

export type StoredCommentSliceOpts = {
  storedCommentsMap: {[key: LineKey | FileKey]: boolean}
}

export const createStoredCommentSlice =
  ({
    storedCommentsMap,
  }: StoredCommentSliceOpts): StateCreator<StoredCommentSlice, [['zustand/devtools', never]], [], StoredCommentSlice> =>
  (set, get) => ({
    storedCommentsMap,
    getStoredCommentDataForLine: (lineKey: LineKey | FileKey) => {
      const storedCommentMap = get().storedCommentsMap
      return storedCommentMap[lineKey]
    },
    updateStoredCommentOnLine: (lineKey: LineKey | FileKey, hasStoredComment: boolean) => {
      if (!hasStoredComment && get().storedCommentsMap[lineKey]) {
        set(
          prevState => ({
            storedCommentsMap: {
              ...prevState.storedCommentsMap,
              [lineKey]: false,
            },
          }),
          undefined,
          'updateDiffLines',
        )
      } else if (hasStoredComment && !get().storedCommentsMap[lineKey]) {
        //there is no need to push out stateful updates when adding a stored comment, so just update the map
        get().storedCommentsMap[lineKey] = true
      }
    },
  })
